import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { CanComponentDeactivate } from "../../../shared/guards/can-deactivate.guard";

import { BrandCampaign } from "../../../shared/models/brandCampaign";
import { DialogService } from "../../../shared/services/dialog.service";
import { BrandUrl } from "../../brand.url";
import { BrandCampaignService } from "../shared/services/brand-campaign.service";
import { PartnersSheetProcessingProgressService } from "../shared/services/partners-sheet-processing-progress.service";
import { BrandService } from "../../../shared/services/api/brand.service";

@Component({
  selector: "app-brand-campaign",
  templateUrl: "./brand-campaign.component.html",
  styleUrls: ["./brand-campaign.component.scss"],
})
export class BrandCampaignComponent
  implements OnInit, OnDestroy, CanComponentDeactivate
{
  protected loadingError = false;

  private campaign?: BrandCampaign;
  private subscriptions = new Subscription();

  constructor(
    private readonly brandCampaignService: BrandCampaignService,
    private readonly brandService: BrandService,
    private readonly dialogService: DialogService,
    private readonly partnersSheetProcessingProgress: PartnersSheetProcessingProgressService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
  ) {}

  public ngOnInit(): void {
    this.getCampaign();
  }

  public ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }

  public canDeactivate(): Promise<boolean> | boolean {
    const isPartnersSheetMatching =
      this.partnersSheetProcessingProgress.progress === 100 &&
      this.route.snapshot.url.some((url) =>
        url.path.includes("invite-partners"),
      );

    if (!isPartnersSheetMatching) {
      return true;
    }

    return this.dialogService.confirm({
      title: "brand.partnerImportList.confirmCancelMatching.title",
      message: "brand.partnerImportList.confirmCancelMatching.message",
    });
  }

  private getCampaign(): void {
    this.subscriptions.add(
      this.brandCampaignService.currentBrandCampaign$.subscribe((campaign) => {
        if (campaign) {
          this.setCampaign(campaign);
        }
      }),
    );
  }

  private setCampaign(campaign: BrandCampaign): void {
    if (campaign) {
      this.campaign = campaign;

      if (
        this.campaign.isEditable &&
        this.route.snapshot.url.some((url) => url.path.includes("dashboard"))
      ) {
        this.router.navigateByUrl(
          BrandUrl.Campaign.DetailsSettings(
            this.brandService.currentBrandId,
            this.campaign.id,
          ),
        );
      }
    }
  }

  protected isCampaignLoaded(): boolean {
    return !!this.campaign && !this.loadingError;
  }

  protected async reloadCampaign(): Promise<void> {
    this.loadingError = false;

    await this.brandCampaignService
      .loadBrandCampaign(this.brandCampaignService.currentBrandCampaignId)
      .catch(() => (this.loadingError = true));
  }
}
